import React, { useEffect, useState } from "react";

import "./mobileSettings.css";
import AWS from "aws-sdk";
import EditIcon from "../../assets/icon/Edit.svg";
import UserIcon from "../../assets/icon/Profile.svg";
import PhoneIcon from "../../assets/icon/Mobile.svg";
import EmailIcon from "../../assets/icon/Mail.svg";
import PasswordIcon from "../../assets/icon/Password.svg";
import LocationIcon from "../../assets/icon/Location.svg";
import UserInfoItems from "./components/UserInfoItems";

import DefaultImg from "../../assets/img/avatar-face.jpg";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  countryCodes,
  profileImageUpload,
  userDelete,
  userDetails,
  userLogout,
} from "../../services/MainApiDetails";
import { User } from "../../actions";
// import profile_image from "../../utilities/constants.json";
import Moment from "moment";
import EditNameModal from "./components/EditNameModal";
import AddPhoneModal from "./components/AddPhoneModal";
import EditAddressModal from "./components/EditAddressModal";

import LanguageSwitch from "./components/LanguageSwitch";

import constants from "../../utilities/constants.json";
import EditTeamModal from "./components/EditTeamModal";
import EditContactModal from "./components/EditContactModal";
import useScrollToTop from "../../hooks/useScrollToTop";
import DeleteAccountModal from "../../components/deleteUser/DeleteAccountModal";

const imageUrl = constants.profile_image;

const MobileSettings = () => {
  const userProfile = useSelector((state) => state.userData.items);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);

  useScrollToTop();

  useEffect(() => {
    getUserDetails();
  }, []);
  function getUserDetails() {
    if (userProfile.length == 0 && localStorage.webKey) {
      userDetails().then((response) => {
        if (response.data.status === 1) {
          dispatch(User(response.data.user_data));
        }
      });
    }
  }
  useEffect(() => {
    if (userProfile) {
      let addres = "";
      if (userProfile.address)
        addres += userProfile.address + ", PIN:" + userProfile.zip_code + ", ";
      if (userProfile.state) addres += userProfile.state + ", ";
      if (userProfile.country) addres += userProfile.country;
      setAddress(addres);
    }
  }, [userProfile]);

  function changeLanguage(value) {
    // alert(value);
    localStorage.setItem("language", value);
    window.location.reload();
  }

  function imageUpload(e) {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
  
    const reader = new FileReader();
  
    reader.onloadend = () => {
      const base64String = reader.result;
  
      const data = { image: base64String };
      profileImageUpload(data)
        .then((response) => {
          if (response.data.status === 1) {
            alert("Image uploaded successfully");
            window.location.reload();
          }
        })
        .catch((err) => {
          console.error(err);
        }).finally(() => {
          setLoading(false);
        })
    };
  
    reader.readAsDataURL(file);
  }

  // Handle logout
  const handleLogout = () => {
    userLogout()
      .then((res) => {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // Handle account deletion
  const handleDeleteAccount = () => {
    console.log("Delete Account Clicked");
  setShowDeleteAccount(true); 
  };

  function logoutUser() {
    
  }

  // Mobile Responsive
  const [windowDimension, setWindowDimension] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;
  // Mobile Responsive
  return (
    <div className="mobileSettings">
      <div className="mobileSettings-wrapper">
        {isMobile ? (
          <div className="mobileSettings-top-goback">
            <Link to="/mobile-profile">
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Settings</p>
            </Link>
          </div>
        ) : (
          <div className="mobileSettings-top-goback">
            <Link to="/">
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Settings</p>
            </Link>
          </div>
        )}

        <div className="mobileSettings-profileChange-wrapper">
          <div className="mobileSettings-profileImg-change-wrapper">
            <div className="mobileSettings-profileImg-wrapper">
                {loading ? (
      <div className="profileImg-loader">
        <div className="spinner"></div>
      </div>
    ) : (
      <img
        src={userProfile.image ? imageUrl + userProfile.image : DefaultImg}
        alt=""
      />
    )}
            </div>
{!loading &&
            <form action="" enctype="multipart/form-data">
              <div className="mobileSettings-image-inputBox">
                <label for="inputTag">
                  <div className="image-upload-wrapper">
                    <div className="image-text-wrapper">
                      <img src={EditIcon} alt="" />
                    </div>
                    <input
                      id="inputTag"
                      type="file"
                      accept="image/png, image/jpg, image/gif, image/jpeg"
                      onChange={(e) => imageUpload(e)}
                    />
                  </div>
                </label>
              </div>
            </form>}
          </div>

          {/* <div className="mobileSettings-languageSwitch-wrapper">
            <p className="switch-text">Switch your questions language</p>
            <div className="language-switchBtn-wrapper">
              <button
                className={
                  localStorage.language != "en"
                    ? "switch-btn-selected"
                    : "switch-btn"
                }
                onClick={() => changeLanguage("ml")}
              >
                MALAYALAM
              </button>
              <button
                className={
                  localStorage.language == "en"
                    ? "switch-btn-selected"
                    : "switch-btn"
                }
                onClick={() => changeLanguage("en")}
              >
                ENGLISH
              </button>
            </div>
          </div> */}

          {/*<LanguageSwitch changeLanguage={changeLanguage} />*/}

          <div className="mobileSettings-userInfo-wrapper">
            {/* User Name */}
            <UserInfoItems
              userInfoIcon={UserIcon}
              userInfoTitle="User Name"
              userInfoText={userProfile.name}
              IconShow={true}
              editType={<EditNameModal name={userProfile.name} />}
            />
            {/* Phone Number */}
            <UserInfoItems
              userInfoIcon={PhoneIcon}
              userInfoTitle="Phone Number"
              userInfoText={userProfile.phone}
              IconShow={true}
              editType={<EditContactModal field="phone" currentValue={userProfile.phone} currentDialCode={localStorage.country_code ? "+" + localStorage.country_code : "+91"} />}
            />
            {/* Email */}
            <UserInfoItems
              userInfoIcon={EmailIcon}
              userInfoTitle="Email"
              userInfoText={userProfile.email}
              IconShow={true}
              editType={<EditContactModal field="email" currentValue={userProfile.email} />}
            />
            <UserInfoItems
              userInfoIcon={UserIcon}
              userInfoTitle="Team"
              userInfoText={userProfile.team?.team_name}
              IconShow={true}
              editType={<EditTeamModal team={userProfile.team} />}
            />
            {/* Password */}
            {!localStorage.is_mobile ? (
              <Link
                to="/mobile-forgot-password"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <UserInfoItems
                  userInfoIcon={PasswordIcon}
                  userInfoTitle="Password"
                  userInfoText="Change Password"
                  IconShow={true}
                />
              </Link>
            ) : (
              ""
            )}
            {/* Alternative Mobile Number */}
            <UserInfoItems
              userInfoIcon={PhoneIcon}
              userInfoTitle="Alternative Contact Number"
              userInfoText={userProfile.alt_phone ?? "Click to add"}
              IconShow={true}
              editType={<AddPhoneModal phone={userProfile.alt_phone} />}
            />
            {/* Address */}
            <UserInfoItems
              userInfoIcon={LocationIcon}
              userInfoTitle="Address"
              userInfoText={!!userProfile?.address ? address : "Click to add"}
              smallContent={!!userProfile?.address}
              IconShow={true}
              editType={
                <EditAddressModal
                  address={userProfile.address ?? ""}
                  postalCode={userProfile.zip_code ?? ""}
                  country={userProfile.country ?? ""}
                  state={userProfile.state ?? ""}
                />
              }
            />
          </div>

          {/* Bottom Actions Section */}
          <div className="mobileSettings-bottom-actions">
            <button 
              className="logout"
              onClick={handleLogout}
            >
              Logout
            </button>
            <p 
              className="delete-account-btn"
              onClick={handleDeleteAccount}
            >
              Delete Account
            </p>
          </div>
        </div>
      </div>
      <DeleteAccountModal showDeleteAccount={showDeleteAccount} setShowDeleteAccount={setShowDeleteAccount}/>
    </div>
  );
};

export default MobileSettings;